// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ajuste{
    margin-left: 5px;
}

.linea{
    display: inline !important;
}

.centrar-pantalla{
    margin: 0 auto;
    width: auto;
    margin-top: 10%px;
}

.alert-simulation{
    color: #a94442;
    background-color: #f2dede;
    border-color: #ebccd1;
    border: 1px solid transparent;
}

.divBordered{
    padding: 10px;
    border: 1px solid;
    border-radius: 16px;
    margin: 10px;
}

.ajuste-lista{
    margin-left: 30px;
}

.urlDescarga{
    text-decoration: underline;
}

.spanUnderline{
    text-decoration: underline
}`, "",{"version":3,"sources":["webpack://./src/app/pages/items-example/items-example.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI;AACJ","sourcesContent":[".ajuste{\r\n    margin-left: 5px;\r\n}\r\n\r\n.linea{\r\n    display: inline !important;\r\n}\r\n\r\n.centrar-pantalla{\r\n    margin: 0 auto;\r\n    width: auto;\r\n    margin-top: 10%px;\r\n}\r\n\r\n.alert-simulation{\r\n    color: #a94442;\r\n    background-color: #f2dede;\r\n    border-color: #ebccd1;\r\n    border: 1px solid transparent;\r\n}\r\n\r\n.divBordered{\r\n    padding: 10px;\r\n    border: 1px solid;\r\n    border-radius: 16px;\r\n    margin: 10px;\r\n}\r\n\r\n.ajuste-lista{\r\n    margin-left: 30px;\r\n}\r\n\r\n.urlDescarga{\r\n    text-decoration: underline;\r\n}\r\n\r\n.spanUnderline{\r\n    text-decoration: underline\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
